import { useRef, useState } from 'react';
import { BottomSheet } from '@/ui/components';
import { noEntry } from '@/assets/images/emojis';
import { Button } from '@/ui/components/Button';
import styles from './MultipleLoanRestrictionModal.module.scss';

export interface MultipleLoanRestrictionModalProps {
  expireInDays: number;
  durationDays: number;
  closedContracts: number;
  maxContracts: number;
}

export function useMultipleLoanRestrictionModal({
  expireInDays,
  durationDays,
  closedContracts,
  maxContracts,
}: MultipleLoanRestrictionModalProps) {
  const [isOpen, setIsOpen] = useState(false);
  const cancelButtonRef = useRef<HTMLButtonElement>(null);

  const handleConfirm = () => {
    setIsOpen(false);
  };

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  const title = `Ai accesat deja ${closedContracts} ${
    closedContracts === 1 ? 'împrumut' : 'împrumuturi'
  } luna aceasta`;

  const description1 = `Numărul maxim permis este de ${maxContracts} credite contractate în decurs de ${durationDays} de zile.`;

  const description2 = `Te așteptăm înapoi peste ${
    expireInDays === 1 ? `${expireInDays} zi` : `${expireInDays} zile`
  }, când vei putea aplica pentru un credit nou.`;

  const content = (
    <div className={styles.container}>
      {/* Emoji */}
      <div className={styles.emoji}>
        <img src={noEntry} alt="No Entry" className={styles.emojiImage} />
      </div>

      {/* Content */}
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.descriptionContainer}>
          <p className={styles.description}>{description1}</p>
          <p className={styles.description}>{description2}</p>
        </div>
      </div>
    </div>
  );

  const footer = (
    <div className={styles.buttons}>
      <Button
        trackingId="acknowledge_multiple_loan_restriction"
        variant="filled"
        onClick={handleConfirm}
        text="Am înțeles"
        className={styles.buttonContinue}
      />
    </div>
  );

  return {
    open,
    close,
    modal: (
      <BottomSheet
        open={isOpen}
        onOpenChange={setIsOpen}
        ariaLabel={title}
        ariaDescription={description1}
        enableDrag={true}
        closeOnOverlay={true}
        footer={footer}
        initialFocusRef={cancelButtonRef}
      >
        {content}
      </BottomSheet>
    ),
  };
}
